import {
  ACCEPT_REJECT,
  ACCEPT_REJECT_SUCCESS,
  ACCEPT_REJECT_FAILURE,
} from "../actionTypes";

export const kycAuth = (payload) => ({
  type: ACCEPT_REJECT,
  payload,
});

export const kycAuthSuccess = (payload) => ({
  type: ACCEPT_REJECT_SUCCESS,
  payload,
});

export const kycAuthFailure = () => ({
  type: ACCEPT_REJECT_FAILURE,
});
